<template>
	<div v-if="isVisible" class="app-cover">
		<span class="app-cover__use-tablet">Please, use tablet or desktop</span>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		isVisible: Boolean,
	},
});
</script>

<style lang="scss">
.app-cover {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 2rem;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 99999;
	color: $color-dark;
	font-size: 2.4rem;
	line-height: 1.24;
	pointer-events: none;
	background-color: $color-light;

	&__use-tablet {
		text-align: center;
	}
}
</style>
